import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// resume
import resume from "./assets/resume/resume.pdf";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Navbar, Nav, Row, Col, Card } from "react-bootstrap";
// profile
import profile from "./assets/profile.png";
import profile1 from "./assets/profile1.png";


// experience
import experience from "./assets/project/vettapas-project.png";
import experience1 from "./assets/project/I2S-Website-Project.png";
// achievements
import achievements from "./assets/achievment/isro.jpg";
import achievements1 from "./assets/achievment/nit.jpg";
import achievements2 from "./assets/achievment/sahc.png";
import achievements3 from "./assets/achievment/icsp.jpg";
import achievements4 from "./assets/achievment/dicv.jpg";
import achievements5 from "./assets/achievment/bcet.png";
// project
import project from "./assets/project/proj_1.png";
import project1 from "./assets/project/vettapas-project.png";
import project2 from "./assets/project/proj_3.jpg";
import project3 from "./assets/project/proj_7.png";
import project5 from "./assets/project/proj_5.png";
import project6 from "./assets/project/proj_6.jpeg";
import project7 from "./assets/project/I2S-Website-Project.png";

// certifications
import certCognizant from "./assets/certification/Cognizant_Hackathon.png";
import certBadge from "./assets/certification/Hackathon_Badge.png";
import certWB from "./assets/certification/Internship_Certificate_wb.png";
import certGoogle from "./assets/certification/Google_Cloude_AI.jpeg";
import certAICTE from "./assets/certification/AICT.jpeg";
import certIEEE from "./assets/certification/IEEE.jpeg";
import certBCET from "./assets/certification/Workshop_BCET_Cognizant.jpeg";
import certNIT from "./assets/certification/bootcamp_in_NIT.jpg";
import certLearnCode from "./assets/certification/learn_code.jpg";
// video
// import projectVideo from "./assets/project/project1.mp4";
// import projectVideo1 from "./assets/project/project2.mp4";
// import projectVideo2 from "./assets/project/project5.mp4";
// import projectVideo3 from "./assets/project/project3.mp4";
// import projectVideo4 from "./assets/project/project7.mp4";

import { FaLinkedinIn, FaGithub, FaYoutube, FaInstagram, FaWhatsapp, FaFacebook } from "react-icons/fa";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFileDownload } from "react-icons/fa";

export default function Portfolio() {
  const [count, setCount] = useState(0);
  const [showAllAchievements, setShowAllAchievements] = useState(false);
  const [showAllProjects, setShowAllProjects] = useState(false);
  const [showAllCertifications, setShowAllCertifications] = useState(false);

  const experienceData = [
    { img: experience, title: "Vet-Tapas-Website", desc1: "Web Developer Intern – Government of West Bengal. Worked on real-world web applications, dashboards, and deployment projects with live users.", desc2: "Tech Use: HTML, CSS, BOOTSTRAP, JAVASCRIPT, PHP, MYSQL", link: "https://vettapas.com" },
    { img: experience1, title: "I2S – Ideas to Solution Website", desc1: "Designed and developed a complete business website for a client, integrating multiple service modules, including ERP, IoT, Education, and Commerce solutions.", desc2: "Tech Use: HTML, CSS, BOOTSTRAP, JAVASCRIPT, PHP, MYSQL", link: "https://i2s.co.in" }
  ];

  const achievementsData = [
    { img: achievements5, title: "CyberCon Cybersecurity Seminar – BCET", desc: "Participated in the CyberCon Cybersecurity Seminar at BCET, organized by The Drop Organization, Durgapur." },
    { img: achievements, title: "ISRO Interaction Program", desc: "Participated in ISRO’s official interaction program in Kolkata." },
    { img: achievements1, title: "UAV Bootcamp – NIT Durgapur", desc: "Certified in UAV and drone technologies from NIT Durgapur." },
    { img: achievements2, title: "Government Internship", desc: "Web development intern at the Government of West Bengal." },
    { img: achievements3, title: "ICSP Tech Certification", desc: "Certified participant of the ICSP technology conference, Kolkata." },
    { img: achievements4, title: "Best Student Award", desc: "Recognized for academic excellence on Foundation Day." },
  ];

  const projectsData = [
    { img: project7, title: "Project: I2S – Ideas to Solution Platform", desc1: "Developed a full-stack responsive business platform offering services like Cloud ERP, IoT Smart Hub, and Tourism solutions, responsive multi-service platform with dark/light mode, modern UI, and dynamic service modules.", desc2: "HTML, CSS, JavaScript, BOOTSTRAP, PHP, MYSQL", link: "https://i2s.co.in" },
    { img: project6, title: "Project: AI Criminal Face Detection System", desc1: "Real-time face detection and criminal identification system using a custom CNN model with live webcam monitoring and an alert system.", desc2: "Python, OpenCV, TensorFlow/Keras, Flask, NumPy, HTML, CSS, Bootstrap, Custom CNN", link: "https://github.com/rabishankar21" },
    { img: project, title: "Project: Smart AI Traffic Assistance", desc1: "Built an AI-powered traffic management system using computer vision to optimize signal timing and reduce congestion.", desc2: "Python, OpenCV, TensorFlow, YOLO, Flask", link: "https://github.com/rabishankar21/ai-traffic-dashboard" },
    { img: project1, title: "Project: A Veterinary Blogging And consultancy Website", desc1: "Developed a full-stack website for veterinary blogs and online consultation with modern UI and backend support.", desc2: "HTML, CSS, JavaScript, BOOTSTRAP, PHP, MYSQL", link: "https://vettapas.com" },
    { img: project5, title: "Project: E-Commerce Website Prototype", desc1: "Designed a basic e-commerce prototype with database integration.", desc2: "HTML, CSS, JAVASCRIPT, BOOTSTRAP, PHP, MYSQL", link: "#" },
    { img: project2, title: "Project: Megamart Sales Dashboard", desc1: "Designed an interactive sales dashboard with data visualization and insights for business performance analysis.", desc2: "Power BI, CSV, Python, Pandas, Numpy, Matplotlib, Seaborn", link: "https://github.com/rabishankar21/megamart-ecommerce-sales-dashboard" },
    { img: project3, title: "Project: Lok-MArt Sales Dashboard", desc1: "Created a dynamic analytics dashboard to track sales trends, revenue, and customer insights.", desc2: "Power BI, CSV, Python, Pandas, Numpy, Matplotlib, Seaborn", link: "https://github.com/rabishankar21/Lok-Mart-Sales-Dashboard" }
  ];

  const certificationsData = [
    { 
      images: [certBadge, certCognizant], 
      title: "Cognizant Hackathon & Badge", 
      desc: "Earned official badge and certificate for participating in the Cognizant Hackathon." 
    },
    { 
      img: certWB, 
      title: "Govt. of West Bengal Internship", 
      desc: "Official certification for Web Development Internship under the Government of West Bengal." 
    },
    { 
      img: certGoogle, 
      title: "Google Cloud AI", 
      desc: "Completed Google Cloud AI certification, gaining expertise in machine learning and cloud platforms." 
    },
    { 
      img: certAICTE, 
      title: "AICT Certification", 
      desc: "Recognized certification from AICT." 
    },
    { 
      img: certIEEE, 
      title: "IEEE Certification", 
      desc: "Certified by the Institute of Electrical and Electronics Engineers (IEEE) for technical excellence." 
    },
    { 
      img: certNIT, 
      title: "UAV Bootcamp – NIT Durgapur", 
      desc: "Certified in UAV and drone technologies from the National Institute of Technology, Durgapur." 
    },
    { 
      img: certBCET, 
      title: "Cognizant Workshop – BCET", 
      desc: "Participated in an exclusive tech workshop organized by Cognizant at BCET." 
    },
    { 
      img: certLearnCode, 
      title: "Learn Code Certification", 
      desc: "Certified for completing intensive coding and software development training." 
    }
  ];

  const countRef = useRef(null);
  const animatedRef = useRef(false);
  const canvasRef = useRef(null);

  useEffect(() => {
    AOS.init({
      offset: 150,
      duration: 800,
      once: false,
    });

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !animatedRef.current) {
        animatedRef.current = true;
        setTimeout(() => {
          let startTimestamp = null;
          const duration = 2500; // 2.5 seconds duration
          const target = 30;
          
          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            // Exponential ease-out function for smooth deceleration
            const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            setCount(Math.floor(easeProgress * target));
            
            if (progress < 1) {
              window.requestAnimationFrame(step);
            } else {
              setCount(target);
            }
          };
          window.requestAnimationFrame(step);
        }, 600); // 600ms delay after scrolling into view
      }
    }, { threshold: 0.5 });

    if (countRef.current) {
      observer.observe(countRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    
    const frameCount = 444; 
    const images = [];

    const drawImageCover = (ctx, img) => {
      const hRatio = canvas.width / img.width;
      const vRatio = canvas.height / img.height;
      const ratio = Math.max(hRatio, vRatio);
      const centerShift_x = (canvas.width - img.width * ratio) / 2;
      const centerShift_y = (canvas.height - img.height * ratio) / 2;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, img.width, img.height,
                    centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);
    };

    let targetFrame = 1;
    let currentFrame = 1;
    let animationFrameId;

    // Initialize image objects
    for (let i = 1; i <= frameCount; i++) {
      images[i] = new Image();
    }

    // Load first frame immediately to show background instantly
    const firstSrc = require(`./assets/frames/frame_001.webp`);
    images[1].src = firstSrc.default || firstSrc;
    images[1].onload = () => {
      drawImageCover(context, images[1]);
    };

    // Stagger loading the rest to keep UI smooth and prioritize main content
    setTimeout(() => {
      for (let i = 2; i <= frameCount; i++) {
        setTimeout(() => {
          const paddedIndex = i.toString().padStart(3, '0');
          const src = require(`./assets/frames/frame_${paddedIndex}.webp`);
          images[i].src = src.default || src;
        }, i * 15); // Add a small 15ms delay between each image request
      }
    }, 500); // Start background loading 500ms after initial render

    const renderLoop = () => {
      currentFrame += (targetFrame - currentFrame) * 0.08;
      
      let frameIndex = Math.round(currentFrame);
      if (frameIndex < 1) frameIndex = 1;
      if (frameIndex > frameCount) frameIndex = frameCount;

      const img = images[frameIndex];
      if (img && img.complete && img.naturalWidth > 0) {
        drawImageCover(context, img);
      }
      
      animationFrameId = requestAnimationFrame(renderLoop);
    };

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight;
      if (maxScrollTop <= 0) return;
      
      const scrollFraction = scrollTop / maxScrollTop;
      let frameIndex = Math.floor(scrollFraction * frameCount) + 1;
      
      if (frameIndex > frameCount) frameIndex = frameCount;
      if (frameIndex < 1) frameIndex = 1;
      
      targetFrame = frameIndex;
    };

    const handleResize = () => {
      const dpr = window.devicePixelRatio || 1;
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      
      const img = images[Math.round(currentFrame)];
      if (img && img.complete && img.naturalWidth > 0) {
        drawImageCover(context, img);
      }
      handleScroll();
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    renderLoop();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className="app-wrapper">
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          pointerEvents: "none",
          filter: "brightness(0.45)"
        }}
      />
      {/* Navbar */}
      {/* Premium Navbar */}
      <Navbar
        expand="lg"
        fixed="top"
        style={{
          background: "rgba(2,6,23,0.7)",
          backdropFilter: "blur(14px)",
          borderBottom: "1px solid #1f2937",
          padding: "10px 0"
        }}
        variant="dark"
      >
        <Container>
          <Navbar.Brand href="#home" style={{ fontWeight: "800", fontSize: 22, fontFamily: "'Outfit', sans-serif" }}>
            <span className="text-gradient">Rabi Shankar</span> Singh
          </Navbar.Brand>

          <Navbar.Toggle />

          <Navbar.Collapse>
            <Nav className="ms-auto" style={{ gap: "20px", alignItems: "center" }}>
              {[
                ["Home", "#home"],
                ["About", "#about"],
                ["Experience", "#experience"],
                ["Achievements", "#achievements"],
                ["Certifications", "#certifications"],
                ["Projects", "#projects"],
                ["Contact", "#contact"]
              ].map(([name, link]) => (
                <Nav.Link
                  key={name}
                  href={link}
                  style={{
                    color: "#e5e7eb",
                    fontWeight: 500,
                    transition: "0.3s"
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#38bdf8")}
                  onMouseLeave={(e) => (e.target.style.color = "#e5e7eb")}
                >
                  {name}
                </Nav.Link>
              ))}

             <a href="mailto:rabidgp2004@gmail.com" style={{ textDecoration: 'none' }}>
  <button className="btn-premium">
    Hire Me
  </button>
</a>

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <section
        id="home"
        data-aos="fade-up"
        style={{
          paddingTop: 120,
          paddingBottom: 80,
          color: "white",
          position: "relative",
          overflow: "hidden",
          background: "transparent"
        }}
      >
        <Container style={{ position: "relative", zIndex: 2 }}>
          <Row className="align-items-center">
            <Col lg={6} md={12} className="text-center text-lg-start">

              <h1 className="fw-bold hero-title-1">
                <span className="typing">Hello</span>
              </h1>
              <h1 className="fw-bold hero-title-2">
                <span className="typing">I'm Rabi Shankar Singh</span>
              </h1>
              <h4 className="mt-3">
                <span className="typing2 text-gradient">AI/ML Engineer & Web Developer</span>
              </h4>
              <p className="mt-3 hero-subtitle">
                I build AI-powered apps, dashboards, and full-stack web applications.
              </p>
              <a href={resume} download style={{ textDecoration: 'none' }}>
                <button className="btn-outline-premium mt-4">Download Resume</button>
              </a>
            </Col>
            <Col lg={6} md={12} className="text-center mt-4 mt-lg-0">

              <div className="hero-image-container">
                <img
                  src={profile}
                  alt="Rabi Shankar Singh - AI/ML Engineer Profile"
                  className="rounded-circle shadow img-fluid enhanced-img"
                  style={{ width: "100%" }}
                />
                <div className="social-overlay">
                  <a href="https://youtube.com/@datadrivenbyrabi?si=574BbkxGJojWmgZn" target="_blank" rel="noreferrer"><FaYoutube /></a>
                  <a href="https://www.linkedin.com/in/rabi-shankar-singh-b142b6264/" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
                  <a href="https://github.com/rabishankar21" target="_blank" rel="noreferrer"><FaGithub /></a>
                  <a href="https://www.instagram.com/rabi_sankar112?igsh=aHptZTVsNXoyaXJx" target="_blank" rel="noreferrer"><FaInstagram /></a>
                </div>
              </div>


            </Col>
          </Row>
        </Container>

        <style>{`
          .typing {
            white-space: nowrap;
            overflow: hidden;
            display: inline-block;
            animation: typing 2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          }

          .typing2 {
            white-space: nowrap;
            overflow: hidden;
            display: inline-block;
            width: 0;
            animation: typing2 2.5s cubic-bezier(0.4, 0, 0.2, 1) 1.5s forwards;
          }

          @keyframes typing {
            from { width: 0 }
            to { width: 100% }
          }

          @keyframes typing2 {
            from { width: 0 }
            to { width: 100% }
          }

          @keyframes blink {
            50% { border-color: transparent }
          }

          /* 3D CARD EFFECT */
.card3d {
  border: 1px solid #1f2937;
  position: relative;
  overflow: hidden; /* important */
}

.card3d:hover {
  transform: rotateY(8deg) rotateX(6deg) scale(1.05);
  box-shadow: 0 0 25px rgba(56,189,248,0.5),
              0 0 60px rgba(56,189,248,0.2);
  border-color: #38bdf8;
}

.card3d img {
  transition: transform 0.4s ease;
  border-radius: 10px 10px 0 0;
}


.card3d:hover img {
  transform: translateZ(30px) scale(1.05);
}

          @keyframes float {
            0%,100% { transform: translateY(0px); }
            50% { transform: translateY(-30px); }
          }
        `}
        </style>
      </section>

      {/* About */}
        <section id="about" className="py-5" data-aos="fade-up" style={{ backgroundColor: "transparent", color: "var(--text-primary)" }}>
        <Container>
          <h2 className="text-center mb-5 fw-bold"><span className="text-gradient">About Me</span></h2>

          <Row className="align-items-start">
            {/* LEFT SIDE */}
            <Col lg={4} md={12} className="mb-4">
              <div className="text-center mb-4 fadeUp">
                <img
                  src={profile1}
                  alt="Rabi Shankar Singh - Professional AI Developer"
                  className="enhanced-img"
                  style={{
                    width: 160,
                    height: 160,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "4px solid #38bdf8"
                  }}
                />
              </div>

              <div className="fadeUp">
                <h6 className="mb-3">Skills</h6>
                {[
                  ["Python", 85],
                  ["Machine Learning", 80],
                  ["Data Analysis", 75],
                  ["HTML/CSS/JS", 75],
                  ["MySQL", 70]
                ].map(([name, val]) => (
                  <div key={name} className="mb-3">
                    <small>{name} {val}%</small>
                    <div style={{ background: "#1f2937", height: 6, borderRadius: 10 }}>
                      <div
                        style={{
                          width: `${val}%`,
                          height: 6,
                          background: "var(--gradient-glow)",
                          borderRadius: 10,
                          transition: "width 1.5s",
                          boxShadow: "0 0 10px rgba(56, 189, 248, 0.5)"
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Col>

            {/* RIGHT SIDE */}
            <Col lg={8} md={12} className="fadeUp">
              <p style={{ lineHeight: 1.8 }}>
                I am a B.Tech Computer Science (AI & ML) student passionate about building
                real-world AI solutions and full-stack applications. I enjoy combining
                Artificial Intelligence with practical development to create impactful
                digital products.
              </p>

              <p style={{ lineHeight: 1.8 }}>
              I have developed and deployed an official veterinary hospital website as 
              voluntary social impact work to support free animal treatment and welfare.
               My work has been recognized by NSPCL and West Bengal Veterinary authorities. 
               I am passionate about using technology to solve meaningful problems and create positive impact.
              </p>
              <div className="mt-4" style={{ fontSize: 15 }}>
                {[
                  ["Profile", "Artificial Intelligence & Machine Learning"],
                  ["Domain", "AI/ML, Computer Vision, Web Applications, Social Impact Projects"],
                  ["Education", "B.Tech in Computer Science & Engineering (AI & ML) – Pursuing"],
                  ["Language", "English, Hindi & Bengali"],
                  ["BI Tools", "Python, OpenCV, Pytorch, TensorFlow, Flask, Git & GitHub"],
                  ["Other Skills", "MySQL, REST APIs, Deployment (GoDaddy, cPanel), PDF Generation"],
                  ["Interest", "Animal Welfare, Building Useful Technology, Learning New Skills"]
                ].map(([label, value]) => (
                  <div key={label} className="about-grid-item" style={{ display: "grid", gridTemplateColumns: "140px 1fr", marginBottom: 8 }}>
                    <span style={{ fontWeight: 600, color: "#94a3b8" }}>{label}:</span>
                    <span>{value}</span>
                  </div>
                ))}
              </div>
              <div className="mt-4 fadeUp" ref={countRef}>
                <h3
                  style={{
                    fontWeight: 700,
                    background: "linear-gradient(90deg, #7dd3fc, #4ade80, #d8b4fe)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    filter: "drop-shadow(0px 0px 10px rgba(74, 222, 128, 0.6)) drop-shadow(0px 4px 6px rgba(0,0,0,0.8))",
                    marginBottom: 12
                  }}
                >
                  <span>{count}+</span> Projects Completed 
                </h3>

                <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                  <button className="btn-premium">
                    Connect on LinkedIn
                  </button>
                </a>
              </div>
            </Col>
          </Row>

          {/* animation */}
          <style>{`
            .fadeUp {
              opacity: 0;
              transform: translateY(30px);
              animation: fadeUp 1s ease forwards;
            }

            @keyframes fadeUp {
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}</style>
        </Container>
      </section>

      {/* Experience / Education / Achievements */}
      <section id="experience" className="py-5" style={{ backgroundColor: "transparent" }}>
        <Container>
          <h2 className="text-center mb-5 fw-bold"><span className="text-gradient">Experience</span></h2>
          <Row>
            {experienceData.map((exp, idx) => (
              <Col xs={12} sm={6} md={6} lg={4} className="mb-4" data-aos="fade-up" key={idx}>
                <Card className="h-100 premium-card">
                  <Card.Img variant="top" src={exp.img} className="enhanced-img" alt={"Rabi Shankar Singh - " + exp.title + " Experience"} />
                  <Card.Body>
                    <Card.Title className="fw-bold">{exp.title}</Card.Title>
                    <Card.Text style={{ fontSize: 14, color: "var(--text-secondary)" }}>
                      {exp.desc1}
                    </Card.Text>
                    <Card.Text style={{ fontSize: 14, color: "var(--accent-purple)", fontWeight: 500 }}>
                      {exp.desc2}
                    </Card.Text>
                    <a href={exp.link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                      <button className="btn-outline-premium w-100 mt-2">View Website</button>
                    </a>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

            {/* Achievements */}
            <section id="achievements" className="py-5" style={{ backgroundColor: "transparent" }}>
        <Container>
          <h2 className="text-center mb-5 fw-bold"><span className="text-gradient">Achievements</span></h2>
          <Row>
            {achievementsData.slice(0, showAllAchievements ? achievementsData.length : 6).map((ach, idx) => (
              <Col xs={12} sm={6} md={6} lg={4} className="mb-4" data-aos="fade-up" key={idx}>
                <Card className="h-100 premium-card">
                  <Card.Img variant="top" src={ach.img} className="enhanced-img" alt={"Rabi Shankar Singh - " + ach.title + " Achievement"} />
                  <Card.Body>
                    <Card.Title>{ach.title}</Card.Title>
                    <Card.Text style={{ fontSize: 14 }}>
                      {ach.desc}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {achievementsData.length > 6 && (
            <div className="text-center mt-4">
              <button className="btn-outline-premium" onClick={() => setShowAllAchievements(!showAllAchievements)}>
                {showAllAchievements ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </Container>
      </section>

      {/* Certifications */}
      <section id="certifications" className="py-5" style={{ backgroundColor: "transparent" }}>
        <Container>
          <h2 className="text-center mb-5 fw-bold"><span className="text-gradient">Certifications</span></h2>
          <Row>
            {certificationsData.slice(0, showAllCertifications ? certificationsData.length : 6).map((cert, idx) => (
              <Col xs={12} sm={6} md={6} lg={4} className="mb-4" data-aos="fade-up" key={idx}>
                <Card className="h-100 premium-card">
                  {cert.images ? (
                    <div style={{ display: "flex", width: "100%", height: "220px", borderBottom: "1px solid #1e293b", backgroundColor: "rgba(2, 6, 23, 0.9)" }}>
                      <img className="enhanced-img" src={cert.images[0]} style={{ width: "30%", height: "100%", objectFit: "contain", padding: "10px", borderRight: "1px dashed #334155" }} alt={"Rabi Shankar Singh - " + cert.title + " Badge"} />
                      <img className="enhanced-img" src={cert.images[1]} style={{ width: "70%", height: "100%", objectFit: "contain", padding: "10px" }} alt={"Rabi Shankar Singh - " + cert.title + " Certificate"} />
                    </div>
                  ) : (
                    <Card.Img variant="top" src={cert.img} className="enhanced-img" alt={"Rabi Shankar Singh - " + cert.title + " Certification"} />
                  )}
                  <Card.Body>
                    <Card.Title>{cert.title}</Card.Title>
                    <Card.Text style={{ fontSize: 14 }}>
                      {cert.desc}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {certificationsData.length > 6 && (
            <div className="text-center mt-4">
              <button className="btn-outline-premium" onClick={() => setShowAllCertifications(!showAllCertifications)}>
                {showAllCertifications ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </Container>
      </section>

      {/* Projects */}
      <section id="projects" className="py-5" style={{ backgroundColor: "transparent" }}>
        <Container>
          <h2 className="text-center mb-5 fw-bold"><span className="text-gradient">Projects</span></h2>
          <Row>
            {projectsData.slice(0, showAllProjects ? projectsData.length : 6).map((proj, idx) => (
              <Col xs={12} sm={6} md={6} lg={4} className="mb-4" data-aos="fade-up" key={idx}>
                <Card className="h-100 premium-card">
                  <Card.Img variant="top" src={proj.img} className="enhanced-img" alt={"Rabi Shankar Singh - " + proj.title + " Project"} />
                  <Card.Body>
                    <Card.Title>{proj.title}</Card.Title>
                    <Card.Text style={{ fontSize: 14 }}>
                      {proj.desc1}
                    </Card.Text>
                    <Card.Text style={{ fontSize: 14 }}>
                      {proj.desc2}
                    </Card.Text>
                    <a href={proj.link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                      <button className="btn-outline-premium w-100 mt-2">View Project</button>
                    </a>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {projectsData.length > 6 && (
            <div className="text-center mt-4">
              <button className="btn-outline-premium" onClick={() => setShowAllProjects(!showAllProjects)}>
                {showAllProjects ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </Container>
      </section>

      {/* Contact */}
      <section id="contact" className="py-5 contactSec" style={{ backgroundColor: "transparent" }}>
  <Container>
    <style>{`
    /* CONTACT SECTION */
.contactSec {
  background: transparent;
  color: var(--text-primary);
}

.contactCard {
  padding: 25px;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 36px;
  transition: all 0.3s ease;
  color: var(--text-primary);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.7), inset 0 3px 5px rgba(255, 255, 255, 0.15), inset 0 -3px 5px rgba(0, 0, 0, 0.4);
}
.contactCard a {
  color: var(--accent-cyan);
  transition: color 0.3s;
}
.contactCard a:hover {
  color: var(--accent-purple);
}

.contactCard:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(167, 139, 250, 0.3);
  border-color: var(--accent-purple);
}

.contactCard .icon {
  font-size: 28px;
  margin-bottom: 10px;
  color: var(--accent-purple);
}

.socials span {
  display: inline-block;
  margin: 8px;
  background: var(--bg-card);
  padding: 10px 14px;
  border-radius: 50%;
  transition: 0.3s;
}

.socials a {
  display: inline-block;
  margin: 8px;
  background: var(--bg-card);
  border: 1px solid var(--glass-border);
  padding: 12px;
  border-radius: 50%;
  color: var(--text-primary);
  font-size: 18px;
  transition: all 0.3s ease;
}

.socials a:hover {
  background: var(--gradient-primary);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(167, 139, 250, 0.4);
}

.icon {
  font-size: 28px;
  color: var(--accent-purple);
  margin-bottom: 10px;
}
.floating-whatsapp { position: fixed; right:18px; bottom:18px; z-index:9999; border-radius:50%; width:56px; height:56px; display:flex; align-items:center; justify-content:center; background:#25D366; color:#fff; box-shadow:0 8px 24px rgba(37,211,102,0.4); font-size:22px; transition: transform 0.3s ease; }
.floating-whatsapp:hover { transform: scale(1.1); }
a {
  text-decoration:none;
}
[data-aos] {
  transition-property: transform, opacity !important;
}

          `}</style>
    <h2 className="text-center mb-2 fw-bold"><span className="text-gradient">Contact Me</span></h2>
    <p className="text-center mb-5" style={{ color: "var(--text-secondary)" }}>
      Below are the details to reach out to me!
    </p>

   

<Row className="text-center justify-content-center" data-aos="fade-up">
  {[
    [<FaMapMarkerAlt />, "ADDRESS", "West Bengal, India"],
    [<FaPhoneAlt />, "CONTACT NUMBER", <a href="tel:+917001408918">+91-7001408918</a>,],
    [<FaEnvelope />, "EMAIL ADDRESS", <a href="mailto:rabidgp2004@gmail.com" className="text-decoration-none">
    rabidgp2004@gmail.com
  </a>],
    [
  <FaFileDownload />,
  "DOWNLOAD RESUME",
  <a href={resume} download className="text-decoration-none">
    Download
  </a>
]

  ].map(([icon, title, value]) => (
    <Col xs={12} sm={6} md={6} lg={3} className="mb-4" key={title}>
      <div className="contactCard">
        <div className="icon">{icon}</div>
        <h6>{title}</h6>
        <p>{value}</p>
      </div>
    </Col>
  ))}
</Row>


    {/* CTA */}
    <div className="text-center mb-4">
      <h3 className="fw-bold"><span className="text-gradient">Have a Question?</span></h3>
      <a href="mailto:rabidgp2004@gmail.com" style={{ textDecoration: 'none' }}>
      <button className="btn-premium mt-2">CLICK HERE</button></a>
    </div>

    {/* Social */}
    <div className="text-center">
      <p style={{ color: "var(--text-secondary)" }}>Find me on</p>
      <div className="socials">
  <a href="https://youtube.com/@datadrivenbyrabi?si=574BbkxGJojWmgZn"><FaYoutube /></a>
  <a href="https://www.linkedin.com/in/rabi-shankar-singh-b142b6264/"><FaLinkedinIn /></a>
  <a href="https://www.facebook.com/profile.php?id=100071437804367"><FaFacebook /></a>
  <a href="https://github.com/rabishankar21"><FaGithub /></a>
  <a href="https://www.instagram.com/rabi_sankar112?igsh=aHptZTVsNXoyaXJx"><FaInstagram /></a>
</div>

    </div>
  </Container>
</section>


      {/* Footer */}
      <footer className="text-center py-3" style={{ backgroundColor: "transparent", color: "var(--text-secondary)", borderTop: "1px solid var(--glass-border)" }}>
        © 2026 Rabi Shankar Singh. All rights reserved.
      </footer>
      {/* Floating WhatsApp */}
  <a href="https://wa.me/919635140634" target="_blank" rel="noreferrer" className="floating-whatsapp" title="Chat on WhatsApp">
    <FaWhatsapp />
  </a>
    </div>

  );

}
